
          $(document).ready(function(){
            if(sessionStorage.getItem("mhaPages")){}
            else
            {
              sessionStorage.setItem("mhaPages",JSON.stringify([]));
            }            
            
            mhaPagesOld = JSON.parse(sessionStorage.getItem("mhaPages"));
            if($.inArray(window.location.href,mhaPagesOld)){
              mhaPagesOld.push(window.location.href);
              sessionStorage.setItem("mhaPages", JSON.stringify(mhaPagesOld) );
            } 
          });
          var isMobile = window.matchMedia("only screen and (max-width: 769px)");
          var country;
          var mhaIsOpen = false;
          var mha_device = 'desktop';
          $(document).on('keyup', '#oanEmail', function(event) {
            if (event.keyCode === 13) {
              $('#mhaOanSubscribe').click();
            }
          });
          function readCookie(name) {
            return (name = new RegExp('(?:^|;\\s*)' + ('' + name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)').exec(document.cookie)) && name[1];
          }

          function writeCookie(cName,cVal,cExpMin=0) {
            newDate = new Date;
            deleteCookie(cName);
            if(cExpMin==0){
              document.cookie = cName+"="+cVal+";"
            }
            else{
              document.cookie = cName+"="+cVal+";expires="+new Date((newDate.getTime() + newDate.getTimezoneOffset() * 60000) + (cExpMin * 60000))+";path=/;"
            }
            
          }
          function deleteCookie(name) {
            document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
          }
          if (isMobile.matches) {
            mha_device = 'mobile';
          }
          if(!readCookie("mha_popup")){
            $.getJSON("https://freegeoip.net/json/", function (data) {
              country = data.country_name;
              $.ajax({
                url: 'https://dev-masterapp.hulkapps.com/oan_popup/frontend/get_oan_popup_html',
                type: 'GET',
                data: {shop_id: window.masterapp.store_id,page: window.location.href,device: mha_device,country: country}
              })
              .done(function(data) {
                console.log('dattaaaaaaaa------>',data);
                $.getScript('https://dev-masterapp.hulkapps.com/plugin_js/bootstrap_modal.js', function () {
                  $('#mhaOanPopup').html(data.oan_popup_html);

                  switch (data.dis_cond) { 
                    case 'seconds':
                      console.log('seconds',(parseInt(data.dis_val)*1000));
                      setTimeout(function(){
                          open_modal();
                        },(parseInt(data.dis_val)*1000))
                      break;
                    case 'pagecount':
                      console.log('pagecount',(JSON.parse(sessionStorage.getItem("mhaPages")).length) == data.dis_val);
                      if(JSON.parse(sessionStorage.getItem("mhaPages")).length >= data.dis_val){
                          open_modal();
                        }                          
                      break;
                    case 'scroll':
                      console.log('scroll');
                      $(window).on('scroll', function(){
                          var s = $(window).scrollTop(),
                              d = $(document).height(),
                              c = $(window).height();

                          var scrollPercent = (s / (d - c)) * 100;
                          if(scrollPercent >= data.dis_val && !mhaIsOpen){
                            open_modal();
                            mhaIsOpen = true;
                          }
                          console.log(scrollPercent);
                        })
                      break;
                    case 'onexit':
                      console.log('onexit');
                      $(document.documentElement).on('mouseleave',function(e){
                          if(e.clientY < 20 && !mhaIsOpen){
                            console.log(e.clientY)
                            open_modal();
                            mhaIsOpen = true;
                          }
                        });
                      break;
                    default:
                      console.log('no any display condition');
                  }
                  function open_modal(){
                    $('#mhaOanPopup .modal').on('shown.bs.modal', function () {
                      if(data.position != 'center'){
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                      }
                      writeCookie("mha_popup","true",data.delay_time|| 0);
                      var popup = $('#mhaOanModal').attr('data-popup');
                      $.ajax({
                          url: 'https://dev-masterapp.hulkapps.com/oan_popup/frontend/popup_viewed',
                          type: 'GET',
                          data: {shop_id: window.masterapp.store_id,popup: popup,country: country}
                        })
                    });
                    if(data.position == 'center'){
                      $('#mhaOanModal').modal();
                    }else{
                      $('#mhaOanModal').modal({backdrop: 'static'});
                    }
                  }

                });
              });
            });
            $(document).on('click', '.rmv-mha-oanpopup', function(event) {
              $('#mhaOanModal').modal('hide');
              $('#mhaOanPopup').html('');
            });
            $(document).on('click', '#mhaOanSubscribe', function(event) {
              mha_oan_email = $('#oanEmail').val();
              var mha_emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
              console.log('here',mha_oan_email);
              if(mha_emailReg.test( mha_oan_email ) && mha_oan_email){
                $.ajax({
                  url: 'https://dev-masterapp.hulkapps.com/oan_popup/frontend/subscribe_oan_popup',
                  type: 'GET',
                  data: {shop_id: window.masterapp.store_id,email: mha_oan_email,country: country}
                })
                .done(function(data) {
                  console.log('subscribed data------>',data);
                  if (data.oan_popup_html) {
                    $('#mhaOanPopup .modal-content').html(data.oan_popup_html);
                  }
                  else{
                    $('#mhaOanModal').modal('hide');
                  }
                })
                .fail(function() {
                  console.log('error');
                })
                .always(function() {
                  console.log('complete');
                });
              }else{
                $('#oanEmail').css('border','1px solid red');
              }
            });
          }
        